if (!customElements.get('product-size-guide')) {
  customElements.define('product-size-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      const link = this.querySelector('a');
      const dialog = this.querySelector('dialog');
      if (!link || !dialog || typeof dialog.showModal !== 'function') return;
      this.initialized = true;
      link.addEventListener('click', (event) => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        dialog.showModal();
      });
      dialog.querySelector('button').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right ||
            event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
      });
    }
  });
}
